import type IconWrapperStyle from './types';

const style: IconWrapperStyle = {
    top: 2,
};

export default style;
